import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import React from 'react';
import { CircularProgress, IconButton, Stack, Tooltip, Typography } from '@mui/material';

export interface DocumentActionIconsProps {
  hasPdf: boolean;
  hasImages: boolean;
  documentId: number;
  downloadingImagesDocumentId?: number | null;
  onViewPdf: () => void;
  onViewImages: () => void;
  onDownloadImages: () => void;
  /** Optional file download shown for PDF documents (e.g. staff uploads). */
  onDownloadFile?: () => void;
  downloadingFileDocumentId?: number | null;
}

const DocumentActionIcons: React.FC<DocumentActionIconsProps> = ({
  hasPdf,
  hasImages,
  documentId,
  downloadingImagesDocumentId = null,
  onViewPdf,
  onViewImages,
  onDownloadImages,
  onDownloadFile,
  downloadingFileDocumentId = null,
}) => {
  if (!hasPdf && !hasImages) {
    return <Typography variant='caption'>—</Typography>;
  }

  return (
    <Stack direction='row' alignItems='center' spacing={0.5}>
      {hasPdf && (
        <>
          <Tooltip title='View PDF'>
            <IconButton size='small' aria-label='View PDF' onClick={onViewPdf}>
              <PictureAsPdfIcon fontSize='small' />
            </IconButton>
          </Tooltip>
          {onDownloadFile && (
            <Tooltip title='Download'>
              <span>
                <IconButton
                  size='small'
                  aria-label='Download'
                  onClick={onDownloadFile}
                  disabled={downloadingFileDocumentId !== null}
                >
                  {downloadingFileDocumentId === documentId ? (
                    <CircularProgress size={16} />
                  ) : (
                    <FileDownloadOutlinedIcon fontSize='small' />
                  )}
                </IconButton>
              </span>
            </Tooltip>
          )}
        </>
      )}
      {hasImages && (
        <>
          <Tooltip title='View Images'>
            <IconButton size='small' aria-label='View Images' onClick={onViewImages}>
              <ImageIcon fontSize='small' />
            </IconButton>
          </Tooltip>
          <Tooltip title='Download'>
            <span>
              <IconButton
                size='small'
                aria-label='Download'
                onClick={onDownloadImages}
                disabled={downloadingImagesDocumentId !== null}
              >
                {downloadingImagesDocumentId === documentId ? (
                  <CircularProgress size={16} />
                ) : (
                  <FileDownloadOutlinedIcon fontSize='small' />
                )}
              </IconButton>
            </span>
          </Tooltip>
        </>
      )}
    </Stack>
  );
};

export default DocumentActionIcons;
